import { Component, effect, input, model, output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { sanitizeFields, validateBlank, validateYearsLimitFromToday, watchFormRecursively } from '../../../shared/utils/form-utils';

import { ButtonModule } from 'primeng/button';
import { DatePickerModule } from 'primeng/datepicker';
import { FloatLabelModule } from 'primeng/floatlabel';
import { FormFieldFeedbackPipe } from '../../../pipes/form-field-feedback/form-field-feedback.pipe';
import { MedicalHistory } from '../../../shared/models/medical-history';
import { MessageService } from 'primeng/api';
import { TextareaModule } from 'primeng/textarea';
import { TooltipModule } from 'primeng/tooltip';
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'app-medical-history-form',
  imports: [
    TooltipModule,
    ReactiveFormsModule,
    FormFieldFeedbackPipe,
    DatePickerModule,
    TextareaModule,
    ButtonModule,
    FloatLabelModule
  ],
  templateUrl: './medical-history-form.component.html',
  styleUrl: './medical-history-form.component.scss'
})
export class MedicalHistoryFormComponent {
  readonly medicalHistoryForm = new FormGroup({
    detail: new FormControl<string>('', {
      validators: [
        Validators.required,
        validateBlank()
      ]
    }),
    date: new FormControl<Date>(new Date(), {
      validators: [
        Validators.required,
        validateYearsLimitFromToday(20, true)
      ]
    }),
    allergies: new FormControl<string>(''),
    healthProblems: new FormControl<string>(''),
    medication: new FormControl<string>('')
  });

  readonly today = new Date();

  readonly initialData = input<MedicalHistory | null>(null);
  readonly onSubmit = output<any>();
  readonly enabled = model<boolean>(true);
  readonly isLoading = model<boolean>(false);
  readonly id = uuidv4();


  readonly formWatched = watchFormRecursively(this.medicalHistoryForm);

  constructor(private readonly messageService: MessageService) {
    effect(() => {
      if (this.enabled()) {
        this.medicalHistoryForm.enable();
      } else {
        this.medicalHistoryForm.disable();
      }
    });

    effect(() => {
      if (this.initialData()) {
        this.enabled.set(false);
        this.medicalHistoryForm.patchValue(this.initialData()!);
      } else {
        this.enabled.set(true);
        this.resetForm();
      }
    });
  }

  resetForm(): void {
    this.medicalHistoryForm.reset();
    this.isLoading.set(false);
  }

  submitForm(): void {
    this.isLoading.set(true);

    if (this.medicalHistoryForm.invalid) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Preencha todos os campos corretamente!',
        life: 4000
      });

      this.isLoading.set(false);
      return;
    }

    sanitizeFields(this.medicalHistoryForm);
    this.onSubmit.emit(this.medicalHistoryForm.value);
  }
}
